{
	"backLinkTitle": "Back to Manage declarations"
}
